var _path, _path2, _path3, _path4, _path5, _path6, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 10.6362C14.5 11.3893 13.9404 11.9999 13.25 11.9999C12.5596 11.9999 12 11.3893 12 10.6362",
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.6362C12 11.3893 11.4404 11.9999 10.75 11.9999C10.0596 11.9999 9.5 11.3893 9.5 10.6362",
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49991 10.6364C9.49991 11.3895 8.94027 12 8.24991 12C7.55956 12 6.99991 11.3895 6.99991 10.6364C6.99991 10.6364 6.96605 10.1172 6.99991 9.78734C7.0979 8.83275 7.96205 7.52631 7.96205 7.52631C8.09864 7.20534 8.39353 7 8.71791 7H15.2819C15.6063 7.00001 15.9012 7.20535 16.0377 7.5263C16.0377 7.5263 16.9019 8.8327 16.9999 9.78727C17.0338 10.1171 16.9999 10.6364 16.9999 10.6364C16.9999 11.3895 16.4403 12 15.7499 12C15.0596 12 14.4999 11.3895 14.4999 10.6364",
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9587 16.5453V11.9805",
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04167 16.5454V11.9795",
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5837 16.5453H7.41699",
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.edbf600996698471d951abb5b0425bd8.svg";
export { ForwardRef as ReactComponent };